export default [
  {
    path: '/redirect',
    settings: { hidden: true },
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/',
    name: 'Main',
    // roles: [],
    component: () => import('@/components/HelloWorld'),
    settings: {
      useLayout: true,
      title: 'main.title',
      icon: 'home',
      hidden: false
    }
  },
  {
    path: '/flight-orders',
    name: 'FlightOrders',
    roles: ['INITIATOR', 'PLANNER', 'SUPERVISOR'],
    component: () => import('@/views/flight-order/FlightOrdersView'),
    settings: {useLayout: true, title: 'flight-orders.title', icon: 'list'}
  },
/*  {
    path: '/security/flight-orders-tasks',
    name: 'Security-FlightOrders',
    roles: ['SECURITY_SERVICE'],
    component: () => import('@/views/flight-order/FlightOrdersTasks'),
    props: {
      default: true,
      view: 'security',
      stateNames: ['APPROVING', 'CURATOR-APPROVED'],
      formKey: 'FLIGHT_ORDER_SECURITY_SERVICE_APPROVE',
      resultField: 'securityOrderStatus'
    },
    settings: {useLayout: true, title: 'flight-order-groups.security.title', icon: 'security3', hidden: false}
  },*/
  {
    path: '/final-approve/flight-order-groups',
    name: 'Final-Approver-FlightOrderGroups',
    roles: ['CURATOR'],
    component: () => import('@/views/flight-order/FlightOrdersTasks'),
    props: {
      default: true,
      view: 'final',
      stateNames: ['APPROVING', 'SECURITY-APPROVED'],
      formKey: 'FLIGHT_ORDER_FINAL_APPROVE',
      resultField: 'orderStatus'
    },
    settings: {useLayout: true, title: 'flight-order-groups.final.title', icon: 'userSecurity', hidden: false}
  },
/*  {
    path: '/security/special-lists',
    name: 'Security-SpecialLists',
    roles: ['SECURITY_SERVICE', 'SUPERVISOR'],
    component: () => import('@/views/security/SpecialListsView'),
    props: {default: true, view: 'security'},
    settings: {useLayout: true, title: 'special-lists.title', icon: 'password', hidden: false}
  },*/
  {
    path: '/freights/manage/:flightDate?/:freightId(\\d+)?',
    alias: ['/freights/manage'],
    name: 'Freights',
    component: () => import('@/views/freight/ManageFreightsView'),
    roles: ['PLANNER'],
    settings: {
      useLayout: true,
      title: 'freight.title',
      icon: 'helicopter'
    }
  },
  {
    path: '/freights/approve/:flightDate?/:freightId(\\d+)?',
    alias: ['/freights/approve'],
    name: 'Freights approve',
    roles: ['FREIGHT_APPROVER'],
    component: () => import('@/views/freight/ApproveFreightsView'),
    settings: {
      useLayout: true,
      title: 'freight.approve-title',
      icon: 'helicopter'
    }
  },
  {
    path: '/freights/ak/:flightDate?/:freightId(\\d+)?',
    alias: ['/freights/ak'],
    name: 'Manage freight',
    roles: ['AK_MANAGER'],
    component: () => import('@/views/freight/AkManageFreightsView'),
    settings: {
      useLayout: true,
      title: 'freight.manage-title',
      icon: 'helicopter'
    }
  },
  {
    path: '/freights/finalize/:flightDate?/:freightId(\\d+)?',
    alias: ['/freights/finalize'],
    name: 'Freights finalize',
    roles: ['FREIGHT_FINALIZER'],
    component: () => import('@/views/freight/FinishFreightsView'),
    settings: {
      useLayout: true,
      title: 'freight.finalize-title',
      icon: 'helicopter'
    }
  },
  {
    path: '/flights',
    name: 'Planner flights',
    roles: ['PLANNER'],
    component: () => import('@/views/flight-order/PlannerFlightsView'),
    settings: {useLayout: true, title: 'flights.title', icon: 'list'}
  },
  {
    path: '/transfer-manage',
    name: 'Transfer manager',
    roles: ['TRANSFER_MANAGER'],
    component: () => import('@/views/flight-order/TransferManageView'),
    settings: {useLayout: true, title: 'flights.title', icon: 'list'}
  },
  {
    path: '/medical-check',
    name: 'Medical check',
    roles: ['PARAMEDIC'],
    component: () => import('@/views/flight-order/ParamedicView'),
    settings: {useLayout: true, title: 'flights.title', icon: 'list'}
  },
  {
    path: '/icons',
    name: 'Icons',
    // permissions: [],
    // roles: [],
    component: () => import('@/views/svg-icons'),
    settings: {
      useLayout: true,
      title: 'Icons',
      icon: 'plane',
      hidden: true
    }
  },
  {
    path: '/dictionaries',
    name: 'dictionaries',
    redirect: '/dictionaries/mvz',
    roles: ['PLANNER'],
    settings: {
      useLayout: false,
      title: 'dictionaries.title',
      icon: 'dictionary',
      hidden: false
    },
    children: [
      {
        path: '/dictionaries/mvz',
        name: 'Dictionary-MVZ',
        component: () => import('@/views/dictionaries/MvzView'),
        props: {default: true},
        settings: {useLayout: true, title: 'dictionary.mvz.titleShort', icon: 'dictionary', hidden: false}
      },
      {
        path: '/dictionaries/spp',
        name: 'Dictionary-SPP',
        component: () => import('@/views/dictionaries/SppView'),
        props: {default: true},
        settings: {useLayout: true, title: 'dictionary.spp.titleShort', icon: 'dictionary', hidden: false}
      },
      {
        path: '/dictionaries/agent-agreements',
        name: 'Dictionary-AgentAgreements',
        component: () => import('@/views/dictionaries/AgentAgreementsView'),
        props: {default: true},
        settings: {useLayout: true, title: 'dictionary.agent-agreements.title', icon: 'dictionary', hidden: false}
      },
      {
        path: '/dictionaries/ak-agreements',
        name: 'Dictionary-AkAgreements',
        component: () => import('@/views/dictionaries/AkAgreementsView'),
        props: {default: true},
        settings: {useLayout: true, title: 'dictionary.ak-agreements.titleShort', icon: 'dictionary', hidden: false}
      }
    ]
  },
  {
    path: 'administration',
    name: 'administration',
    redirect: '/administration/settings',
    // roles: ['ADMINISTRATION'],
    roles: ['Me_Admin'],
    settings: {
      useLayout: false,
      title: 'administration.title',
      icon: 'settings_2',
      hidden: false
    },
    children: [
      {
        path: '/administration/settings',
        name: 'Administration-Settings',
        component: () => import('@/views/administration/SettingsView'),
        props: {default: true},
        settings: {useLayout: true, title: 'administration.settings.title', icon: 'settings_2', hidden: false}
      },
      {
        path: '/administration/users',
        name: 'Administration-Users',
        component: () => import('@/views/administration/UsersView'),
        props: {default: true},
        settings: {useLayout: true, title: 'administration.users.title', icon: 'peoples', hidden: false}
      },
      {
        path: '/administration/notification-settings',
        name: 'Administration-Notification-Settings',
        component: () => import('@/views/administration/NotificationSettingsView'),
        props: {default: true},
        settings: {useLayout: true, title: 'administration.notification.title', icon: 'wechat', hidden: false}
      }
    ]
  },
  {
    path: '/reports',
    name: 'Freight reports',
    roles: ['PLANNER'],
    // permissions: ['EXPORT_FREIGHT_REPORTS'],
    component: () => import('@/views/freight/reports/FreightReportsView'),
    settings: {
      useLayout: true,
      title: 'reports.title',
      icon: 'report'
    }
  },
  {
    path: '/plan-fact-report',
    name: 'PlanFactReportView',
    roles: ['PLANNER'],
    component: () => import('@/views/reports/PlanFactReportView'),
    settings: {
      useLayout: true,
      title: 'reports.report-plan-fact',
      icon: 'report'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/genericPages.js